import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';

function ServiceProviderSMSDisclosure({ showDisclosure, setShowDisclosure }) {
  return (
    <Box>
      <Box
        component="button"
        type="button"
        onClick={() => setShowDisclosure(true)}
        style={{
          background: 'none',
          border: 'none',
          textDecoration: 'underline',
          cursor: 'pointer',
          padding: 0,
          font: 'inherit',
        }}
        sx={{ color: 'primary.main' }}>
        <FormattedMessage
          id="SMS_OPT_IN_DISCLOSURE_BUTTON"
          defaultMessage="Disclosure"
        />
      </Box>
      <Dialog open={showDisclosure} onClose={() => setShowDisclosure(false)}>
        <DialogTitle>
          <FormattedMessage
            id="SMS_OPT_IN_DISCLOSURE"
            defaultMessage="SMS Opt-In Disclosure"
          />
        </DialogTitle>
        <DialogContent>
          <Typography>
            <FormattedMessage
              id="INSIGHT_CONTACT_SMS_OPT_IN_DESCRIPTION"
              defaultMessage="By selecting SMS Opt-In, you agree to receive text message notifications about your jobs and updates from Service Xcelerator."
            />
          </Typography>
          <ul style={{ margin: 0, padding: '10px 0 0 17px' }}>
            <li>
              <FormattedMessage
                id="INSIGHT_CONTACT_SMS_OPT_IN_DESCRIPTION_1"
                defaultMessage="Your phone number will not be shared with the customer or sold or shared with third parties for marketing or promotional purposes."
              />
            </li>
            <li>
              <FormattedMessage
                id="INSIGHT_CONTACT_SMS_OPT_IN_DESCRIPTION_2"
                defaultMessage="Msg & Data rates may apply. Msg frequency varies based on service activity. Reply HELP for help."
              />
            </li>
            <li>
              <FormattedMessage
                id="INSIGHT_CONTACT_SMS_OPT_IN_DESCRIPTION_3"
                defaultMessage="You can opt out anytime by changing this setting or replying STOP to any SMS message."
              />
            </li>
          </ul>
          <Stack
            sx={{ justifySelf: 'center', mt: 2 }}
            direction="row"
            spacing={2}>
            <a target="_blank" href="/legal/terms">
              <FormattedMessage
                id="USER_SMS_DISCLOSURE_TERMS"
                defaultMessage="Terms"
              />
            </a>
            <a target="_blank" href="/legal/privacy">
              <FormattedMessage
                id="USER_SMS_DISCLOSURE_PRIVACY"
                defaultMessage="Privacy"
              />
            </a>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button variant="contained" onClick={() => setShowDisclosure(false)}>
            <FormattedMessage id="CLOSE" defaultMessage="Close" />
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default ServiceProviderSMSDisclosure;
